<template>
  <div class="info" :class="{ active: maxOrMini }">
    <div class="info-left">
      <div class="left-top" v-if="planOrAddr">
        <div
          class="view-box-img"
          v-if="queryPlanInfo.graphicImagesUrl != ''"
          :style="
            'background: url(' +
              $store.state.config.fileUrl +
              queryPlanInfo.graphicImagesUrl +
              ') no-repeat center center;background-size: contain;background-size: 100% 100%;'
          "
        >
          <div class="img-head">
            <img
              v-if="queryPlanInfo.graphicImagesUrl != ''"
              class="D3Max"
              @click="viewClick(1)"
              :src="
                !maxOrMini
                  ? require('@/assets/img/schoolBigData/enlarge_icon.png')
                  : require('@/assets/img/schoolBigData/narrow_icon.png')
              "
              alt=""
            />
          </div>
        </div>
        <div class="view-box-img" v-else>
          <span style="font-size:26px;color:#dbe1ff">暂无平面视图 </span>
        </div>
      </div>
      <div class="left-bottom">
        <div class="bottom-title">基本信息</div>
        <div class="bottom-content">
          <div class="list" v-if="infoList.length > 0">
            <div class="li" v-for="(item, index) in infoList" :key="index">
              <div class="li-title">
                {{ item.siteDescription }}
              </div>
              <div class="li-content">
                {{ item.siteNum || "***" }}
              </div>
            </div>
          </div>

          <div v-else class="list-no-data">暂无数据</div>
        </div>
      </div>
    </div>
    <!-- <div class="info-center">
      <dv-decoration-7 class="school-box">
        <span>{{ schoolInfo.schoolName || "***" }} </span>
      </dv-decoration-7>
    </div> -->
    <div class="info-right">
      <div class="right-top">
        <div class="top-title">
          安全工作分项得分
        </div>
        <rate-list-chart
          class="top-chart"
          v-if="sumBasicSiteList.length > 0"
          :echartsData="sumBasicSiteList[0]"
        ></rate-list-chart>
        <div v-else class="no-data">暂无数据</div>
      </div>
      <div class="right-bottom">
        <div class="bottom-title">
          区域评分排名
        </div>
        <div class="list-title">
          <div class="item-left">
            排名
          </div>
          <div class="item-center">
            地区
          </div>
          <div class="item-right">
            得分
          </div>
        </div>
        <div class="school-grade-list" v-if="schoolGradeList.length > 0">
          <div
            class="list-item"
            v-for="(item, index) in schoolGradeList"
            :key="index"
          >
            <div class="item-left">
              <img
                v-if="index == 0"
                class="item-left-img"
                src="@/assets/img/safepostureSchool2/rank-1.png"
                alt=""
              />
              <img
                v-if="index == 1"
                class="item-left-img"
                src="@/assets/img/safepostureSchool2/rank-2.png"
                alt=""
              />
              <img
                v-if="index == 2"
                class="item-left-img"
                src="@/assets/img/safepostureSchool2/rank-3.png"
                alt=""
              />
              <span v-if="index > 2">NO.{{ index + 1 }}</span>
            </div>
            <div class="item-center">
              {{ item.namePlace }}
            </div>
            <div class="item-right">
              {{ item.score }}
            </div>
          </div>
        </div>
        <div v-else class="list-no-data">暂无数据</div>
      </div>
    </div>
  </div>
</template>
<script>
import rateListChart from "./components/rateListChart";
export default {
  name: "basicsInfo",
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      infoList: [],
      schoolGradeList: [], //学校评分列表
      sumBasicSiteList: [], //学校评分图表
      queryPlanInfo: {
        graphicImages: "", //2D视图
        graphicImagesUrl: "" //平面视图（需要拼接前缀）
      },
      planOrAddr: true,
      Zindex: 1,
      dialogVisible: false,
      leftShow: true,
      rightShow: true,
      maxOrMini: false // true代表放大图  false代表缩小图
    };
  },
  created() {},
  components: {
    rateListChart
  },
  mounted() {
    this.getSchoolBasicInfo();
    this.getRankingBasicSite();
    this.getSumBasicSite();
    this.getQueryPlan();
  },
  methods: {
    async getSchoolBasicInfo() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getSchoolBasicInfo(req);
      if (res.code == 200) {
        this.infoList = res.data || [];
      } else if (res.code == 101) {
        this.infoList = [];
      } else {
        this.infoList = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "缺少参数"
        });
      }
    },
    // 获取区域评分列表
    async getRankingBasicSite() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getRankingBasicSite(req, true);
      if (res.code == 200) {
        this.schoolGradeList = res.data || [];
      } else if (res.code == 101) {
        this.schoolGradeList = [];
      } else {
        this.schoolGradeList = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "区域评分列表获取失败"
        });
      }
    },
    // 获取区域评分图表
    async getSumBasicSite() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getSumBasicSite(req, true);
      if (res.code == 200) {
        this.sumBasicSiteList = res.data || [];
      } else if (res.code == 101) {
        this.sumBasicSiteList = [];
      } else {
        this.sumBasicSiteList = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "区域评分图表获取失败"
        });
      }
    },
    // 获取学校图数据
    async getQueryPlan() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getQueryPlan(req, true);
      if (res.code == 200) {
        this.queryPlanInfo = res.data || {
          graphicImages: "", //2D视图
          graphicImagesUrl: "" //平面视图（需要拼接前缀）
        };
        // this.queryPlanInfo.graphicImagesUrl = this.$store.state.config.fileUrl + res.data.graphicImagesUrl
      } else if (res.code == 101) {
        this.queryPlanInfo = {
          graphicImages: "", //2D视图
          graphicImagesUrl: "" //平面视图（需要拼接前缀）
        };
      } else {
        this.queryPlanInfo = {
          graphicImages: "", //2D视图
          graphicImagesUrl: "" //平面视图（需要拼接前缀）
        };
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "学校平面图获取失败"
        });
      }
    },
    // 点击切换视图
    viewSelect(num) {
      if (num == 1) {
        this.planOrAddr = true;
      } else {
        this.planOrAddr = false;
      }
    },
    // 点击放大平面视图或3D视图
    viewClick(num) {
      if (!this.maxOrMini) {
        this.maxOrMini = true;
      } else {
        this.maxOrMini = false;
      }
    },
    dialogClose(val) {
      this.dialogVisible = val;
    }
  },
  destroyed() {},
  watch: {},
  computed: {
    schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  transition: all 0s;
  .info-left {
    width: 1320px;
    // margin-top: 48px;
    margin-right: 20px;
    // height: 80%;
    // perspective: 200;
    // -webkit-perspective: 200;
    // transition: width 1s;
    transition: width 0s;
    .left-top {
      width: 1320px;
      height: 669px;
      .view-box-img {
        width: 100%;
        height: 100%;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .img-head {
          width: 100%;
          height: 75px;
          // background: rgba(15, 26, 77, 0.4);
          position: absolute;
          left: 0;
          top: 0;
          .D3Max {
            display: block;
            position: absolute;
            right: 25px;
            top: 20px;
            width: 25px;
            height: 25px;
            cursor: pointer;
            transition: all 1s;
          }
        }
      }
    }
    .left-bottom {
      margin-top: 10px;
      width: 1320px;
      height: 161px;
      background: url("~@/assets/img/schoolBigData2/basic-left-bottom.png");
      background-size: 100% 100%;
      .bottom-title {
        padding: 19px 0 0 17px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }

      .bottom-content {
        padding: 30px 40px 0 40px;
        .list {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .li {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            margin-right: 100px;
            margin-bottom: 24px;
            .li-title {
              color: #6ff3fa;
              min-width: 88px;
              position: relative;
              &::before {
                display: block;
                content: "";
                width: 3px;
                height: 15px;
                background: #17af6d;
                border-radius: 2px;
                position: absolute;
                left: -6px;
                top: 3px;
              }
            }
            .li-content {
              color: #cecece;
            }
          }
        }
        .list-no-data {
          height: 450px;
          display: flex;
          justify-content: center; /* 水平居中 */
          align-items: center; /* 垂直居中 */
          font-size: 16px;
          color: #b3bef4;
        }
      }
    }
  }
  .info-center {
    .D3Max {
      display: block;
      position: absolute;
      right: 10px;
      top: 112px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      transition: all 1s;
    }

    .view-select {
      width: 264px;
      height: 40px;
      margin: 36px 304px;
      display: flex;
      justify-content: center;
      flex-direction: row;
      background: url("~@/assets/img/schoolBigData/no-pitch-bg.png");
      background-size: 100% 100%;
      transition: all 1s;
      .view-select-item-left {
        width: 50%;
        height: 40px;
        cursor: pointer;
        background: url("~@/assets/img/schoolBigData/plan-pitch.png");
        background-size: 100% 100%;
      }
      .view-select-item-right {
        width: 50%;
        height: 100%;
        cursor: pointer;
        background: url("~@/assets/img/schoolBigData/addr-pitch.png");
        background-size: 100% 100%;
      }
      .view-select-no-pitch {
        width: 50%;
        height: 40px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: #a6b1e7;
      }
    }
  }
  .info-right {
    transition: all 1s;
    .right-top {
      width: 501px;
      height: 311px;
      background: url("~@/assets/img/schoolBigData2/basic-right-top.png");
      background-size: 100% 100%;
      transition: all 1s;
      .top-title {
        padding: 19px 0 0 17px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
      .top-chart {
        margin-top: 20px;
        width: 100%;
        height: calc(100% - 80px);
      }
    }
    .right-bottom {
      margin-top: 20px;
      height: 508px;
      background: url("~@/assets/img/schoolBigData2/basic-right-bottom.png")
        center center no-repeat;
      background-size: 100% 100%;
      transition: all 1s;
      .bottom-title {
        padding: 10px 0 0 17px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
      .list-title {
        margin: 16px auto 0 auto;
        width: 420px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        height: 28px;
        .item-left {
          width: 20%;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #6ff3fa;
        }
        .item-center {
          width: 40%;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #6ff3fa;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .item-right {
          width: 40%;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #6ff3fa;
        }
      }
      .school-grade-list {
        margin: 0 auto;
        width: 420px;
        height: 83%;
        overflow-y: scroll;
        scrollbar-width: none;
        padding-bottom: 10px;
        .list-item {
          margin-bottom: 10px;
          display: flex;
          flex-direction: row;
          background: url("~@/assets/img/safepostureSchool2/list-li-bg.png")
            center center no-repeat;
          background-size: 100% 100%;
          height: 50px;
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3) {
            height: 70px;
          }
          .item-left {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 20%;
            color: #cecece;
            font-size: 16px;
            line-height: 28px;
          }
          .item-center {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40%;
            color: #cecece;
            font-size: 16px;
            line-height: 28px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .item-right {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40%;
            color: #cecece;
            font-size: 16px;
            line-height: 28px;
          }
        }
      }
      .list-no-data {
        height: 320px;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        font-size: 16px;
        color: #b3bef4;
      }
      .grade-info-chart {
        height: 250px;
        margin: 0px 25px 0px 25px;
        .title {
          display: flex;
          flex-direction: row;
          .title-icon {
            margin-top: 20px;
            width: 3px;
            height: 12px;
            margin-left: 16px;
            background-color: #b3bef4;
          }
          .title-content {
            margin-top: 20px;
            margin-left: 16px;
            height: 16px;
            line-height: 16px;
            font-size: 20px;
            color: #b3bef4;
          }
        }
        .classification {
          width: 100%;
          height: 220px;
          overflow: scroll;
          scrollbar-width: none;
        }
        .no-data {
          height: 230px;
          display: flex;
          justify-content: center; /* 水平居中 */
          align-items: center; /* 垂直居中 */
          width: 64px;
          font-size: 16px;
          color: #b3bef4;
        }
      }
    }
  }

  &.active {
    padding: 20px;
    .info-left {
      width: 100%;
      height: 100%;
      margin: 0;
    }
    .left-top {
      width: 100%;
      height: 100%;
    }
    
    .left-bottom {
      width: 0;
      height: 0;
      // display: none;
      opacity: 0;
    }

    .info-center {
      width: calc(74% - 128px);
      background: url("~@/assets/img/schoolBigData/school-view-bg.png");
      background-size: 100% 100%;
      margin: 48px 64px 0px 64px;
      height: 780px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .view-box {
        margin: 16px 26px 2px 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 718px;
        width: calc(100% - 52px);
        padding: 16px 26px;
      }
      .view-box-img {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .D3Max {
        display: block;
        position: absolute;
        right: 10px;
        top: 10px;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
      .view-select {
        height: 40px;
        width: 280px;
        margin: 16px 304px;
        display: flex;
        flex-direction: row;
        background: url("~@/assets/img/schoolBigData/no-pitch-bg.png");
        background-size: 100% 100%;
        .view-select-item-left {
          width: 50%;
          height: 40px;
          cursor: pointer;
          background: url("~@/assets/img/schoolBigData/plan-pitch.png");
          background-size: 100% 100%;
        }
        .view-select-item-right {
          width: 50%;
          height: 100%;
          cursor: pointer;
          background: url("~@/assets/img/schoolBigData/addr-pitch.png");
          background-size: 100% 100%;
        }
        .view-select-no-pitch {
          width: 50%;
          height: 40px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          color: #a6b1e7;
        }
      }
    }
    .info-right {
      width: 0;
      height: 0;
      // display: none;
      .right-top {
        opacity: 0;
      }
      .right-bottom {
        opacity: 0;
      }
    }
  }
}
</style>
